import styles from './HeroSection.module.css'

interface SocialLink {
  href: string
  label: string
  icon: React.ReactNode
}

// Icônes SVG inline — pas de dépendance Font Awesome
const IconEnvelope = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
)

const IconGitHub = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
  </svg>
)

const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
)

const IconX = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
)

const IconStackOverflow = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M15.725 0l-1.72 1.277 6.39 8.588 1.716-1.277L15.725 0zm-3.94 3.418l-1.369 1.644 8.225 6.85 1.369-1.644-8.225-6.85zm-3.15 4.465l-.905 1.94 9.702 4.517.904-1.94-9.701-4.517zm-1.85 4.86l-.44 2.093 10.473 2.201.44-2.092-10.473-2.203zM1.86 17.502l-.43 2.09 10.461 2.199.43-2.09L1.86 17.502zM21 19h-3v2.5h3V19zm-5 0h-3v2.5h3V19zm-5 0H8v2.5h3V19zm-5 0H3v2.5h3V19z" />
  </svg>
)

const SOCIAL_LINKS: SocialLink[] = [
  { href: 'mailto:stevenyambos@gmail.com', label: 'Envoyer un email', icon: <IconEnvelope /> },
  { href: 'https://github.com/StevenYAMBOS', label: 'Profil GitHub', icon: <IconGitHub /> },
  { href: 'https://www.linkedin.com/in/steven-yambos', label: 'Profil LinkedIn', icon: <IconLinkedIn /> },
  { href: 'https://x.com/StevenYambos', label: 'Profil X (Twitter)', icon: <IconX /> },
  { href: 'https://stackoverflow.com/users/17386694/steven-yambos', label: 'Profil Stack Overflow', icon: <IconStackOverflow /> },
]

export function HeroSection() {
  return (
    <section className={styles.hero} aria-label="Présentation">
      {/* Grille décorative en fond */}
      <div className={styles.grid} aria-hidden="true" />

      {/* Orbe ambiant */}
      <div className={styles.orb} aria-hidden="true" />

      <div className={styles.content}>
        {/* Pill badge */}
        {/* <div className={styles.badge} aria-hidden="true">
          <span className={styles.badgeDot} />
          <span>Disponible pour de nouvelles opportunités</span>
        </div> */}

        {/* Titre */}
        <h1 className={styles.title}>
          L'unique, {' '}
          <span className={styles.name}>Steven YAMBOS.</span>
        </h1>

        {/* Rôle */}
        <p className={styles.role}>
          <span className={styles.rolePrefix}>{'<'}</span>
          Développeur Back-End
          <span className={styles.rolePrefix}>{' />'}</span>
        </p>

        {/* Description */}
        <p className={styles.description}>
          Bien le bonjour ! Steven, développeur Back-End basé à Paris. Mes passions tournent autour de la <strong className={styles.highlight}>tech</strong>, l'<strong className={styles.highlight}>open-source</strong> et le <strong className={styles.highlight}>gaming</strong>. Sur mon temps libre j'aime découvrir de nouvelles technologies et  m'intéresser à des domaines divers et variés (souvent dans la tech mine de rien). Il m'arrive de publier des articles et des vidéos à mes heures perdues, vous les retrouverez ici !
        </p>

        {/* Liens sociaux */}
        <div className={styles.actions}>
          <div className={styles.socials}>
            {SOCIAL_LINKS.map(({ href, label, icon }) => (
              <a
                key={href}
                href={href}
                target={href.startsWith('mailto') ? undefined : '_blank'}
                rel={href.startsWith('mailto') ? undefined : 'noopener noreferrer'}
                aria-label={label}
                className={styles.socialLink}
              >
                {icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}